import { CategoryService } from './../../../account/core/services/CategoryService';
import * as _ from "lodash";
import * as swal from "sweetalert"
import {IDatasetService} from "../../core/services/DatasetService";
import {AccountService} from "../../../account/core/services/AccountService";
export class DatasetPageComponent implements ng.IComponentOptions {
  public controller: any = DatasetController;
  public template: string = /*html*/`
    <div class="container container-fluid padding-2">
      <breadcrumb tree="$ctrl.tree"></breadcrumb>
      <div class="card row">
      <div class="col-sm-12">
      <div style="display:flex">
      <h3 ng-class="{'text-danger':$ctrl.dataset.deletedOn}" style="flex-grow:1">
      <span ng-show="$ctrl.dataset.deletedOn" class="data-deleted"><i class="fa fa-fw fa-exclamation-triangle" style="#FFF"></i> Deleted</span>
      <span ng-show="$ctrl.dataset.verification && !$ctrl.dataset.verifiedOn" class="data-pending"><i class="fa fa-fw fa-exclamation-triangle" style="#FFF"></i> Pending Review</span>
      {{$ctrl.dataset.display_name}}
      </h3>
      <div class="btn-group" style="top:0;margin-top:10px;margin-right:10px" ng-style="$ctrl.dataset.verification&&!$ctrl.dataset.verifiedOn?{'width': '680px'}:''" uib-dropdown uib-tooltip="Please login to download data" tooltip-enable="!$ctrl.account.isLogin">
      <a class="btn btn-default" style="background-color: #9f9f9f;color:#FFF" ng-click="$ctrl.back()"><i class="fa fa-fw fa-list"></i> Back to List</a>
      <a class="btn btn-default" ng-href="#/dataview/{{$ctrl.defaultResource._id}}" style="background-color: #4cacd7;color:#FFF" ><i class="fa fa-fw fa-table margin-right"></i>View Data</a>
      <a class="btn btn-default" ng-class="{'inactive': !$ctrl.account.isLogin}" ng-href="{{$ctrl.base+'/download?datasetId='+$ctrl.dataset._id+'&resourceId='+$ctrl.defaultResource._id+'&token='+$ctrl.token}}" style="background-color: #3d8f4f;color:#FFF"><i class="fa fa-fw fa-download margin-right"></i>Download</a>
      ${TARGET==='public'?'':
      `<a class="btn btn-default" ng-if="$ctrl.isAdmin||$ctrl.account.usertype === 'internal'" ng-click="$ctrl.viewActivity()" style="background-color: #cc2c40;color:#FFF"><i class="fa fa-fw fa-tasks margin-right"></i>Activity Stream</a>
        <button ng-if="$ctrl.isOwner||$ctrl.isAdmin" id="extras" type="button" class="btn btn-default" style="height:34px" uib-dropdown-toggle>
          <i class="fa fa-fw fa-cog"></i>
          <span class="sr-only">Extras</span>
        </button>
        <ul ng-if="($ctrl.isOwner||$ctrl.isAdmin)&&$ctrl.dataset.quality!=='poor'" class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="extras">
          <li role="menuitem"><a ng-click="$ctrl.editDataset()"><i class="fa fa-fw fa-pencil-square-o margin-right"></i>Edit</a></li>
          <li role="menuitem" ng-hide="$ctrl.dataset.deletedOn"><a ng-click="$ctrl.deleteDataset()"><i class="fa fa-fw fa-times margin-right"></i>Delete</a></li>
          <li role="menuitem" ng-show="$ctrl.dataset.deletedOn&&$ctrl.isAdmin"><a ng-click="$ctrl.restoreDataset()"><i class="fa fa-fw fa-retweet margin-right"></i>Restore</a></li>
        </ul>
        <button ng-if="$ctrl.isAdmin&&$ctrl.dataset.verification&&!$ctrl.dataset.verifiedOn" id="reviews" type="button" class="btn btn-default" style="height:34px" uib-dropdown-toggle>
          Reviews
        </button>
        <ul ng-if="$ctrl.isAdmin&&$ctrl.dataset.verification&&!$ctrl.dataset.verifiedOn" class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="reviews">
          <li role="menuitem"><a ng-click="$ctrl.approve()"><i class="fa fa-fw fa-pencil-square-o margin-right"></i>Approve</a></li>
          <li role="menuitem" ng-hide="$ctrl.dataset.deletedOn"><a ng-click="$ctrl.deleteDataset()"><i class="fa fa-fw fa-times margin-right"></i>Reject (Delete)</a></li>
        </ul>

      `
      }
      </div>
      </div>
      </div>
      <div class="col-sm-12" ng-show="$ctrl.dataset.quality=='poor'&&$ctrl.dataset.remark">
        <div class="part b-top">
          <p class="clamp-to-3 text-danger">Reject Notes: {{$ctrl.dataset.remark}}</p>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="part b-top">
          <div class="part-70 b-right">
          <p class="clamp-to-3" ng-bind-html="$ctrl.dataset.description"></p>
          </div>
          <div class="part-30 flex">
          <div class="data-subcontent margin-right" style="flex:1 1 0;"><span class="data-subtitle">File Type</span><br>{{$ctrl.defaultResource.extension.substr(1)}}</div>
          <div class="data-subcontent margin-right" style="flex:1 1 0;" ng-show="$ctrl.defaultResource.filesize"><span class="data-subtitle">File Size</span><br><span ng-show="$ctrl.defaultResource.filesize>1000000">{{$ctrl.defaultResource.filesize/1000000 | number:1}}MB</span><span ng-hide="$ctrl.defaultResource.filesize>1000000">{{$ctrl.defaultResource.filesize/1000 | number:0}}kB</span></div>
          <div class="data-subcontent" style="flex:1 1 0;" ng-show="$ctrl.rowCount"><span class="data-subtitle">Number of Rows</span><br>{{$ctrl.rowCount}} rows</div>
          </div>
        </div>
      </div>
      </div>
      <div class="card row m-top-1">
        <div class="col-sm-12">
          <div class="part">
          <div class="part-40 b-right">
            <div class="part">
              <div class="part-50">
                <div class="data-heading">Views</div>
                <div class="data-title">{{$ctrl.dataset.views}}</div>
              </div>
              <div class="part-50">
                <div class="data-heading">Downloads</div>
                <div class="data-title">{{$ctrl.dataset.downloads}}</div>
              </div>
            </div>
            <div class="part b-top">
              <div>
              Data Provided By <br/>
              <div class="data-title">
                <a ng-show="$ctrl.dataset.agency" ng-href="#/search?q={{$ctrl.getSearchString({agency:[$ctrl.dataset.agency.name]})}}">{{$ctrl.dataset.agency.display_name}}</a><span ng-show="$ctrl.dataset.agency">&nbsp;,&nbsp;</span><a ng-show="$ctrl.dataset.agency" ng-href="#/search?q={{$ctrl.getSearchString({ministry:[$ctrl.dataset.agency.ministry.name]})}}">{{$ctrl.dataset.agency.ministry.display_name}}</a>
                <a ng-show="$ctrl.dataset.ministry&&!$ctrl.dataset.agency" ng-href="#/search?q={{$ctrl.getSearchString({ministry:[$ctrl.dataset.ministry.name]})}}">{{$ctrl.dataset.ministry.display_name}}</a>
                <span ng-show="$ctrl.dataset.organization">{{$ctrl.dataset.organization}}</span>
              </div>
              <p style="text-align:justify" ng-hide="$ctrl.dataset.agency" ng-bind-html="$ctrl.dataset.ministry.description"></p>
              <p style="text-align:justify" ng-bind-html="$ctrl.dataset.agency.description"></p>
              </div>
            </div>
          </div>
          <div class="part-60">
          <strong>Dataset Summary</strong>
          <table class="table table-hover table-striped">
            <tr ng-show="$ctrl.dataset.code"><td>Code</td><td>{{$ctrl.dataset.display_code}}</td></tr>
            <tr ng-show="$ctrl.dataset.datatype"><td>Dataset</td><td><a ng-href="#/search?q={{$ctrl.getSearchString({datatype:$ctrl.dataset.datatype.name})}}">{{$ctrl.dataset.datatype.display_name}}</a></td></tr>
            <tr ng-show="$ctrl.dataset.type == 'aggregate'"><td>Group</td><td><a ng-href="#/search?q={{$ctrl.getSearchString({group:[$ctrl.dataset.group.name]})}}">{{$ctrl.dataset.group.name}}</a></td></tr>
            <tr ng-show="$ctrl.dataset.datatype.category"><td>Category</td><td><a ng-href="#/search?q={{$ctrl.getSearchString({category:[$ctrl.dataset.datatype.category]})}}">{{$ctrl.dataset.datatype.category}}</a></td></tr>
            <tr ng-show="$ctrl.dataset.data_date"><td>Time Period</td><td>{{$ctrl.dataset.data_date.start|date:'MMM, yyyy'}} - {{$ctrl.dataset.data_date.end|date:'MMM, yyyy'}}</td></tr>
            <tr ng-show="$ctrl.dataset.datatype.frequency&&$ctrl.dataset.private === false && $ctrl.dataset.internal === false&&$ctrl.dataset.type!=='aggregate'"><td>Data Frequency</td><td>{{$ctrl.dataset.frequency?$ctrl.frequency[$ctrl.dataset.frequency]:$ctrl.frequency[$ctrl.dataset.datatype.frequency]}}</td></tr>
            <tr><td>Content Type</td><td>{{$ctrl.dataset.type|firstCap}}</td></tr>
            <tr><td>Tags</td><td><a class="data-tag" ng-href="#/search?q={{$ctrl.getSearchString({tag:tag})}}" ng-repeat="tag in $ctrl.dataset.tags">{{tag}}</a></td></tr>
            <tr ng-show="$ctrl.dataset.quality"><td>Quality</td><td>{{$ctrl.dataset.quality}}</td></tr>
            ${TARGET==='public'?'':`
            <tr><td>Status</td>
            <td>
              <span ng-show="$ctrl.dataset.private && !$ctrl.dataset.is_processed && $ctrl.dataset.type === 'raw'">Private (Unprocessed)</span>
              <span ng-show="$ctrl.dataset.private && !$ctrl.dataset.is_processed && $ctrl.dataset.type === 'cleansed'">Private</span>
              <span ng-show="$ctrl.dataset.is_processed&&$ctrl.dataset.quality=='good'">Private (Process Pass)</span>
              <span ng-show="$ctrl.dataset.is_processed&&$ctrl.dataset.quality=='poor'">Private (Process Failed)</span>
              <span ng-show="!$ctrl.dataset.private && $ctrl.internal && !$ctrl.dataset.deletedOn">Share to Agency Only</span>
              <span ng-show="!$ctrl.dataset.private && !$ctrl.internal && !$ctrl.dataset.deletedOn">Share to Public</span>
              <span ng-show="$ctrl.dataset.deletedOn">, Deleted</span>
            </td>
            </tr>
            <tr><td>Uploaded By</td><td>{{$ctrl.dataset.user.usertype === 'admin'?'Administrator':$ctrl.dataset.user.fullname}}</td></tr>
            `}
            <tr ng-show="$ctrl.account.isAdmin||($ctrl.dataset.type === 'raw'&&$ctrl.dataset.private)"><td>Created On</td><td>{{$ctrl.dataset.createdOn|date:'MMM, dd yyyy'}}</td></tr>
            <tr><td>Updated On</td><td>{{($ctrl.dataset.updatedOn ||$ctrl.dataset.createdOn)|date:'MMM, dd yyyy'}}</td></tr>
          </table>
          </div>
          </div>
        </div>
      </div>
      <h4>Resources</h4>
      <div class="card row">
        <div class="part" ng-repeat="resource in $ctrl.dataset.resources">
          <div class="part-70 b-right" uib-tooltip="Please login to download data" tooltip-enable="!$ctrl.account.isLogin">
            <a ng-href="#/dataview/{{resource._id}}">{{resource.originalname}}</a>
            <span class="badge-sm" ng-class="$ctrl.getClass(resource.extension)">{{resource.extension.substr(1)}}</span>
            <a class="btn btn-primary pull-right" ng-href="{{$ctrl.base+'/download?datasetId='+$ctrl.dataset._id+'&resourceId='+resource._id+'&token='+$ctrl.token}}" ng-class="{'inactive': !$ctrl.account.isLogin}">Download</a>
          </div>
          <div class="part-30">
            <div class="data-subcontent">
              <div class="data-subtitle">Created</div>
              {{resource.createdOn|date:'MMM, dd yyyy'}}
            </div>
          </div>
        </div>
      </div>
      <h4 ng-show="$ctrl.dataset.relation_id&&(($ctrl.account.agency === $ctrl.dataset.agency._id)||($ctrl.account.ministry === $ctrl.dataset.ministry._id||$ctrl.account.isAdmin))">Origin Datasets</h4>
      <div ng-show="$ctrl.dataset.relation_id&&(($ctrl.account.agency === $ctrl.dataset.agency._id)||($ctrl.account.ministry === $ctrl.dataset.ministry._id||$ctrl.account.isAdmin))" class="card row">
        <div class="part">
        <a class="padding" ng-href="#dataset/{{$ctrl.dataset.relation_id._id}}" >{{$ctrl.dataset.relation_id.display_name}}</a>
        </div>
      </div>
      <h4 ng-show="$ctrl.dataset.linked.length">Related Datasets</h4>
      <div ng-show="$ctrl.dataset.linked.length" class="card row">
        <div class="part" ng-repeat="dataset in $ctrl.dataset.linked">
        <a class="padding" ng-href="#dataset/{{dataset._id}}" >{{dataset.display_name}}</a>
        </div>
      </div>
    </div>
  `;
}

export class DatasetController {
  public static $inject: Array<string> = ["DatasetService", "$stateParams", "AccountService", "$uibModal", "$http", "$location", "$window", "CategoryService"];
  public tree: Array<any>;
  public dataset: any;
  public frequency: any
  public isOwner: boolean;
  public isAdmin: boolean;
  public internal: boolean;
  public rowCount: number;
  public token: string;
  public qString: string;
  public base: string;
  public defaultResource: any
  public category: string
  constructor (private Dataset: IDatasetService, private $stateParams: any, public account: AccountService, private $uibModal: ng.ui.bootstrap.IModalService, private $http: ng.IHttpService, private $location: ng.ILocationService, private $window: ng.IWindowService, private CategoryService) {
    this.tree = [];
    let id = $stateParams.id;
    this.base = BASE;
    Dataset.get({datasetId: id}).$promise.then(data => {
      this.dataset = data;
      this.internal = _.some(data.relations, {internal: true});
      this.category = _.get(this.dataset, 'datatype.category', '')
      if (!this.category && this.dataset.category) {
        CategoryService.query("category")
        .then((d) => {
          this.category = _.get(d.find((cat) => {
            return cat.code === this.dataset.category
          }), 'name', '')
        })
      }
      this.qString = encodeURIComponent(JSON.stringify({category:[this.category]}));
      this.tree.push({name: data.display_name, path: `#/dataset/${data._id}`})
      this.defaultResource = this.dataset.resources.find(r => {
        return r.extension === '.csv'
      })
      if (!this.defaultResource) {
        this.defaultResource = this.dataset.resources[0]
      }
      account.$promise.then(() => {
        this.isOwner = this.dataset.user === account._id || this.dataset.user._id === account._id ;
        this.isAdmin = account.usertype == 'admin';
        this.token = account.token;
      })
      $http.get(`${BASE}/api/dataview/${this.defaultResource._id}`)
      .then((d:any) => {
        this.rowCount = d.data.total;
      })
    })
    .catch(err => {
      if (err.status === 403)
        swal({
          type: "warning",
          title: "Sorry!",
          text: "You've no permission to view this dataset"
        }, () => {
          $window.open("#/search", '_top');
        })
    });
    this.frequency = {
      m: "Monthly",
      q: "Quarterly",
      a: "Annually",
      b: "Biannually",
      o: "One Time"
    }

  }
  public editDataset() {
    let _modalInstance = this.$uibModal.open({
      component: 'datasetModal',
      resolve: {
        dataset: () => {
          return this.dataset;
        }
      }
    });
    _modalInstance.result.then((d) => {
      this.dataset = d;
    })
  }
  public deleteDataset() {
    swal({
      title: "Warning!",
      text: `Are you sure want to delete ${this.dataset.display_name}`,
      type: "warning",
      showCancelButton: true,
    },isConfirm => {
      if (isConfirm) {
        this.$http.delete(`${BASE}/api/dataset/${this.dataset._id}`).then(() => {
          this.$location.path("/dashboard");
        })
        .catch(() => swal("Sorry!", "Failed to delete dataset, please try again later", "error"))
      }
    })
  }
  public restoreDataset() {
    swal({
      title: "Warning!",
      text: `Are you sure want to restore ${this.dataset.display_name}`,
      type: "warning",
      showCancelButton: true,
    },isConfirm => {
      if (isConfirm) {
        this.$http.post(`${BASE}/api/dataset/restore/${this.dataset._id}`,{}).then(() => {
          this.dataset.deletedOn = "";
        })
        .catch(() => swal("Sorry!", "Failed to restore dataset, please try again later", "error"))
      }
    })
  }
  public getSearchString(q: string) {
    return encodeURIComponent(JSON.stringify(q));
  }
  public getClass(ext) {
    switch(ext) {
      case ".csv":
        return "bg-yellow";
      case ".xls":
      case ".xlsx":
        return "bg-green";
      case ".jpg":
      case ".jpeg":
      case ".png":
      case ".gif":
        return "bg-purple";
      case ".pdf":
        return "bg-red";
    }
    return "";
  }
  public viewActivity() {
    let _modalInstance = this.$uibModal.open({
      component: 'activityModal',
      windowClass: 'square-modal',
      resolve: {
        datasetId: () => {
          return this.dataset._id;
        }
      }
    });
    _modalInstance.result.then((d) => {
      this.dataset = d;
    })
  }
  public approve() {
    swal({
      title: 'Confirmation', 
      text: 'Are you sure you want accept this dataset?', 
      type: 'warning',
      confirmButtonText: 'Accept',
      cancelButtonText: 'Reject',
      showCancelButton: true
    }, (confirm) => {
      if (confirm) {
        this.$http.post(`${BASE}/api/dataset/${this.dataset._id}/verify`, {})
        .then((d:any) => {
          this.dataset.verifiedOn = d.data.verifiedOn;
        })
      }
    })
  }
  public back() {
    const url = localStorage.getItem("lastPage")
    if (url) {
      this.$location.url(url)
    }
    else {
      this.$location.url('/search')
    }
  }
}
